import { render, staticRenderFns } from "./SearchBarRounded.vue?vue&type=template&id=ac2e29b2&lang=pug&"
import script from "./SearchBarRounded.vue?vue&type=script&lang=js&"
export * from "./SearchBarRounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports